// removed by extract-text-webpack-plugin
module.exports = {"InformationFormsContainer":"_3h88W6MuDnMVlrCwsmw3Hw","InformationFormsWrapper":"_11Db4cKGED-U28R5xhFfoW","FormStyle":"_2nPzCaIIaDQJ4RqIBzBgPs"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Forms/AreaInput/style.css
// module id = 1394
// module chunks = 0